import PropTypes from 'prop-types'
import React from 'react'
import css from './Signup.module.css'
import DocumentMeta from 'react-document-meta'
import UserStep from './SignupUserStep'
import CompanyStep from './SignupCompanyStep'

const Signup = props => {
  const {
    currentStep,
    enable,
    existingEmail,
    formData,
    invite,
    inviteType,
    isCreatingUser,
    isStrongLead,
    isValidatingEmail,
    onCompanySubmit,
    onFormChange,
    onUserSubmit,
    onEmailBlur
  } = props

  return (
    <div className={css.main} data-currentStep={currentStep}>
      <DocumentMeta title='Create Your Account - Segment' />

      <div className={css.step}>
        <UserStep
          existingEmail={existingEmail}
          enable={enable}
          formData={formData}
          invite={invite}
          inviteType={inviteType}
          isLoading={isCreatingUser || isValidatingEmail}
          onChange={onFormChange}
          onSubmit={onUserSubmit}
          onEmailBlur={onEmailBlur} />
      </div>

      <div className={css.step}>
        <CompanyStep
          formData={formData}
          isLoading={isCreatingUser}
          onChange={onFormChange}
          onSubmit={onCompanySubmit}
          isStrongLead={isStrongLead}
        />
      </div>
    </div>
  )
}

Signup.propTypes = {
  currentStep: PropTypes.string.isRequired,
  enable: PropTypes.object,
  existingEmail: PropTypes.string,
  formData: PropTypes.object,
  invite: PropTypes.object,
  inviteType: PropTypes.string,
  isCreatingUser: PropTypes.bool,
  isStrongLead: PropTypes.bool,
  isValidatingEmail: PropTypes.bool,
  onCompanySubmit: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
  onUserSubmit: PropTypes.func.isRequired
}

export default Signup



// WEBPACK FOOTER //
// ./components/Signup.js